import { IEnumModel } from 'src/app/models/enum.model';
import { SolicitacaoTecnicaService } from "./../../../services/solicitacao-tecnica.service";
import { ISolicitacaoTecnicaModel } from "./../../../models/solicitacao-tecnica.model";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import Swal from "sweetalert2";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { IncluirMatrizRiscoComponent } from './modal-incluir-solicitacao/modal-incluir-matriz-risco.component';
import { MatrizRiscoControleService } from './service/matriz-risco-controle.service';
import { IMatrizRiscoControle } from './model/matriz-risco-controle.model';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import {
	ImprimirMatrizRiscoComponent
} from "./modal-incluir-solicitacao/imprimir-matriz-risco/imprimir-matriz-risco.component";
import { AuthService } from 'src/app/services/auth.service';
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
@Component({
	selector: "aba-matriz-risco-controle",
	templateUrl: "./aba-matriz-risco-controle.component.html",
	styleUrls: ["./aba-matriz-risco-controle.component.scss"],
})
export class AbaMatrizRiscoControleComponent extends BaseListComponent implements OnInit {
	public displayedColumns: string[] = [
		"selecao",
		"siglaUG",
		"nomeProcesso",
		"descricaoCriterioRisco",
	];
	public dataSource = new MatTableDataSource<IMatrizRiscoControle>([]);
	public semDados = true;
	public selectedModel: IMatrizRiscoControle;
	@Input() numeroOpa: string;
	@Input() visualizar: boolean;
	@Input() idPlanejamento: number;
	@Input() dadosPlanejamento: any;
	@ViewChild('printComp') printComp!: ImprimirMatrizRiscoComponent;

	searchNome: string = "";
	public podeImprimir = false;

	constructor(
		private matDialog: MatDialog,
		public router: Router,
		public route: ActivatedRoute,
		private matrizRiscoControleService: MatrizRiscoControleService,
		private authService: AuthService) {
		super();
	}

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	ngOnInit(): void {
		this.podeImprimir = this.authService.possuiPermissao(EnumRecursoPerfil.Planejamento, EnumAcaoRecurso.Imprimir);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	ngAfterViewInit() {
		this.buscar();
	}

	public buscar() {
		this.matrizRiscoControleService
			.obter(this.searchNome, this.idPlanejamento)
			.then((res) => {
				if (res.dados) {
					this.dataSource = new MatTableDataSource<IMatrizRiscoControle>(res.dados);
					this.semDados = this.dataSource.filteredData.length === 0;
					this.dataSource.paginator = this.paginator;
					this.dataSource.sort = this.sort;
					this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
					this.selectedModel = null
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}


	public selecionar(item: any) {
		this.selectedModel =
			!this.selectedModel || this.selectedModel.id !== item.id
				? item
				: null;
	}

	public imprimir(element: IMatrizRiscoControle) {
		this.router.navigate([`/matriz-planejamento/${element.id}/${element.idPlanejamento}/${element.idUnidade}/matriz-risco-imprimir`]);
		//this.router.navigateByUrl(`${this.tipoTrabalho}/${this.tipotrabalhoId}/solicitacao-tecnica/${element?.id}/imprimir`)
	}
	public async exportar(element: IMatrizRiscoControle) {
		const result = await Swal.fire({
			title: element.nomeProcesso,
			text: "Deseja exportar essa Matriz de Riscos?",
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Não",
		});

		if (result.isConfirmed && this.printComp) {
			this.selectedModel = element;

			// Carrega os dados completos antes de exportar
			await this.printComp.carregarDados(element.id, element.idPlanejamento, element.idUnidade);

			// Aguarda um pouco para garantir que os dados foram carregados
			setTimeout(() => {
				this.printComp.exportar();
			}, 100);
		}
	}


	public sortingDataAccessor = (item, property) => {
		switch (property) {
			case "siglaUG":
				return item?.siglaUG;
			case "nomeProcesso":
				return item?.status?.nomeProcesso;
			default:
				return item[property];
		}
	};

	validaInfoBasicas() {
		if (this.dadosPlanejamento == null
			|| this.dadosPlanejamento == undefined
			|| this.dadosPlanejamento.planejamentoUgSubtipo == null
			|| this.dadosPlanejamento.planejamentoUgSubtipo == undefined
			|| this.dadosPlanejamento.planejamentoUgSubtipo.length == 0) {
			this.exibirMensagemAlerta("Aguarde as Informações Básicas do Planejamento carregar!");
			return false;
		}

		return true;
	}

	public incluir(titulo: string, visualizar?: boolean, selectedModel?: IMatrizRiscoControle, importar?: boolean): void {
		if (this.validaInfoBasicas() == false) return;

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-matrizp-risco-controle';
		dialogConfig.width = '80%';
		dialogConfig.height = '90%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			titulo,
			element: selectedModel,
			id: selectedModel?.id,
			idUnidade: selectedModel?.idUnidade,
			visualizar,
			importar,
			planejamentoId: this.idPlanejamento,
			numeroOpa: this.numeroOpa,
			dadosPlanejamento: this.dadosPlanejamento
		};

		const modal = this.matDialog.open(
			IncluirMatrizRiscoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
			this.buscar()
		});
	}

	public excluir(id: number) {
		Swal.fire({
			title: "Excluir Registro",
			text: "Tem certeza que deseja excluir esse Registro?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Não",
		}).then((res) => {
			if (res.value) {
				this.matrizRiscoControleService
					.excluir(id)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					})
					.catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							text: err.mensagem.descricao,
							icon: "error",
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.buscar()
					}
					);
			}
		});
	}
}
